<template>
  <div>
    <!-- 忘记密码 -->
    <el-dialog
      :visible.sync="forgetPwdShow"
      width="500px"
      :footer-hide="true"
      :close-on-click-modal="false"
      @close="resetForm"
    >
      <!-- 账号验证 -->
      <el-form
        ref="accountForm"
        :rules="accountRules"
        class="account-form"
        :model="accountForm"
        v-show="step == 1"
      >
        <div class="title">忘记密码</div>
        <div class="tip">请输入您的账号或手机号</div>
        <el-form-item class="item-input" prop="account" autocomplete="off">
          <i class="el-icon-user"></i>
          <el-input
            type="text"
            v-model="accountForm.account"
            placeholder="请输入您的账号或手机号"
            class="phone"
          ></el-input>
        </el-form-item>
        <div class="btn-box">
          <el-button
            class="next-btn"
            :disabled="!accountForm.account"
            :class="{ 'disabled-btn': !accountForm.account }"
            @click="getPhone"
            >下一步</el-button
          >
        </div>
      </el-form>
      <!-- 身份验证 -->
      <el-form
        ref="phoneCodeForm"
        class="phone-code-form"
        :model="phoneCodeForm"
        :rules="phoneCodeRules"
        v-show="step == 2"
      >
        <div class="title">安全验证</div>
        <div class="tip tip1">为了确保为您本人操作，请先进行安全验证</div>
        <el-form-item class="item-input" prop="account" autocomplete="off">
          <i class="el-icon-user"></i>
          <el-input
            type="text"
            v-model="phone1"
            placeholder="请输入您的账号或手机号"
            class="phone"
            readonly
          ></el-input>
        </el-form-item>
        <el-form-item
          class="item-input"
          prop="mobileVerifyCode"
          autocomplete="off"
        >
          <i class="el-icon-mobile"></i>
          <el-input
            type="text"
            v-model="phoneCodeForm.mobileVerifyCode"
            placeholder="请输入验证码"
            class="code-input"
            @keyup.native.enter.stop="submitForm('loginform')"
          >
          </el-input>
          <span
            @click="getPhoneVerifyCode"
            v-bind:class="getmobilecodeflage ? 'code-btn' : 'hui-btn'"
            >{{
              !isNaN(Number(getmobilecodetext))
                ? `重新发送（${getmobilecodetext}）`
                : getmobilecodetext
            }}</span
          >
        </el-form-item>
        <div class="btn-box btn-box1">
          <el-button
            class="next-btn"
            @click="phoneValid"
            :disabled="!phoneCodeForm.mobileVerifyCode"
            :class="{ 'disabled-btn': !phoneCodeForm.mobileVerifyCode }"
            >下一步</el-button
          >
        </div>
      </el-form>
      <!-- 重置密码-->
      <el-form
        :model="pwdForm"
        :rules="pwdRules"
        ref="pwdForm"
        autocomplete="off"
        v-show="step == 3"
      >
        <div class="title title1">重置密码</div>
        <el-form-item prop="pwd" autocomplete="off" class="item-input">
          <i class="el-icon-lock"></i>
          <el-input
            type="text"
            v-model="pwdForm.pwd"
            placeholder="请输入新密码"
            class="phone"
          ></el-input>
        </el-form-item>
        <el-form-item prop="pwdAgain" autocomplete="off" class="item-input">
          <i class="el-icon-lock"></i>
          <el-input
            type="text"
            v-model="pwdForm.pwdAgain"
            placeholder="请再次输入新密码"
            class="phone"
          ></el-input>
        </el-form-item>
        <div class="pwd-tip">
          注：密码8-16位，且必须包括大小写字母、数字和特殊字符中至少三种类型
        </div>
        <div class="btn-box">
          <el-button
            class="next-btn"
            :disabled="!pwdForm.pwd || !pwdForm.pwdAgain"
            :class="{ 'disabled-btn': !pwdForm.pwd || !pwdForm.pwdAgain }"
            @click="resetPwd"
            >保存</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      forgetPwdShow: false,
      step: 1, //忘记密码步骤
      phone: "",
      phone1: "",
      accountForm: {
        account: "",
      },
      accountRules: {
        account: [
          {
            required: true,
            message: "请输入您的账号或手机号",
            trigger: "blur",
          },
        ],
      },
      phoneCodeForm: {
        mobileVerifyCode: "",
      },
      phoneCodeRules: {
        mobileVerifyCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "change",
          },
        ],
      },
      getmobilecodeflage: true,
      getmobilecodetext: "获取验证码",
      pwdForm: {
        pwd: "",
        pwdAgain: "",
      },
      pwdRules: {
        pwd: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur",
          },
          // {
          //   pattern:
          //     /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/,
          //   message:
          //     "密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种",
          //   trigger: "blur",
          // },
        ],
        pwdAgain: [
          {
            required: true,
            message: "请再次输入新密码",
            trigger: "blur",
          },
          // {
          //   pattern:
          //     /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/,
          //   message:
          //     "密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种",
          //   trigger: "blur",
          // },
        ],
      },
      timer: "",
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    getPhone() {
      this.$refs["accountForm"].validate((valid) => {
        if (!valid) {
          return;
        }
      });
      // 验证账号获取手机号
      this.$http({
        url: "/master/user/checkAccount",
        type: "post",
        params: {
          validateMsg: this.accountForm.account,
        },
      }).then((res) => {
        if (res.data) {
          this.phone = res.data.mobile;
          this.phone1 = (res.data.mobile + "").replace(
            /(\d{3})\d{4}(\d{4})/,
            "$1****$2"
          );
          console.log(this.phone1);
          this.step = 2;
        }
      });
    },
    async sendCode(phone) {
      const signNumber = await this.$tools.phoneSignature();
      this.$http({
        url: "/master/user/sendCode",
        type: "post",
        params: {
          mobile: this.phone,
          source: "login_register",
          signature: signNumber,
        },
      }).then((data) => {
        this.getmobilecodetext = 60;
        this.timer = setInterval(() => {
          this.getmobilecodetext--;
          if (this.getmobilecodetext == 0) {
            this.getmobilecodeflage = true;
            clearInterval(this.timer);
            this.getmobilecodetext = "重新发送";
          }
        }, 1000);
      });
    },
    // 发送验证码
    getPhoneVerifyCode() {
      if (this.phone) {
        if (this.getmobilecodeflage) {
          this.getmobilecodeflage = false;
          this.sendCode();
        }
      } else {
        this.$message.error("请输入手机号");
      }
    },
    //验证手机号
    phoneValid() {
      this.$refs["phoneCodeForm"].validate((valid) => {
        if (!valid) {
          return;
        }
      });
      this.$http({
        url: "/master/user/checkCode",
        type: "post",
        params: {
          mobile: this.phone,
          code: this.phoneCodeForm.mobileVerifyCode,
        },
      }).then((res) => {
        if (res.httpCode == 200) {
          this.step = 3;
        }
      });
    },
    //修改密码
    resetPwd() {
      this.$refs["pwdForm"].validate((valid) => {
        if (!valid) {
          return;
        }
      });
      if (this.pwdForm.pwd != this.pwdForm.pwdAgain) {
        this.$message.error("两次输入密码不一致，请重新输入");
        return;
      }
      this.$http({
        url: "/master/user/reset/password",
        type: "post",
        params: {
          mobile: this.phone,
          newPassword: this.pwdForm.pwdAgain,
        },
      }).then((res) => {
        if (res.httpCode == 200) {
          this.forgetPwdShow = false;
          this.$message.success("密码修改成功");
        }
      });
    },
    resetForm() {
      this.step = 1;
      this.accountForm = {
        account: "",
      };
      this.phoneCodeForm = {
        mobileVerifyCode: "",
      };
      this.pwdForm = {
        pwd: "",
        pwdAgain: "",
      };
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body {
  padding: 0 50px 30px;
}
/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% -30px);
  max-width: calc(100% -30px);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
.item-input {
  background-color: #f7f8fa;
  i {
    color: #808695;
    margin-left: 15px;
  }
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
  /deep/ .el-input__inner {
    border: none;
    outline: none;
    background-color: transparent;
  }
}
.title {
  color: #17233d;
  font-size: 22px;
  text-align: center;
  margin-bottom: 35px;
}
.tip {
  color: #515a6e;
  font-size: 14px;
  margin-bottom: 10px;
}
.tip1 {
  margin-top: -24px;
  text-align: center;
}
.btn-box {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 10px;
}
.btn-box1 {
  margin-top: 40px;
  margin-bottom: 15px;
}
.next-btn {
  width: 120px;
  height: 40px;
  background: #ff8000 !important;
  border-color: #ff8000 !important;
  color: #fff !important;
  opacity: 1;
  border-radius: 4px;
}
.code-input {
  width: 250px;
}
.code-btn {
  color: #2685ff;
  font-size: 16px;
  cursor: pointer;
  padding-left: 25px;
}
.hui-btn {
  color: #727c8e;
  font-size: 16px;
}
.title1 {
  margin-bottom: 25px;
}
.pwd-tip {
  color: #8a9095;
  margin-bottom: 25px;
  line-height: 20px;
}
.disabled-btn {
  background-color: #ffbf91 !important;
  border-color: #ffbf91 !important;
}
</style>
